"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _layouts = require("@indigenux/design/layouts");
var _jsxRuntime = require("react/jsx-runtime");
/* Images */const ServerError = () => {
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_layouts.Main, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("section", {
      class: "page-header page-header-classic",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        class: "container",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          class: "row",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            class: "col",
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("ul", {
              class: "breadcrumb",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
                  href: "index.html",
                  children: "Home"
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
                class: "active text-color-light",
                children: "Error"
              })]
            })
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          class: "row",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            class: "col p-static",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
              "data-title-border": true,
              children: "It's not you, it's us."
            })
          })
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("section", {
      class: "page-header page-header-modern page-header-background page-header-background-md overlay overlay-color-dark overlay-show overlay-op-8 http-error",
      style: "background-image: url(img/errors/404-lock.jpg);",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        class: "container",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          class: "row",
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            class: "col-md-12 mt-4 mt-md-0",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
              class: "text-color-light",
              children: "500"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                class: "text-color-primary",
                children: "Internal server error"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              class: "sub-title",
              children: "We're experiencing some technical difficulties, but we're working on it."
            })]
          })
        })
      })
    })]
  });
};
var _default = exports.default = ServerError;